import React from 'react';
import PropTypes from 'prop-types';
import { Heading_1 as Heading1, PrimaryButton } from '@huggg/react-components';
import dictionary from 'config/dictionary';
import { interpolate } from 'utilities/interpolate';
import BackButton from '../../BackButton/BackButton';
import { BankPaymentInfoDialog } from '../BankPaymentInfoDialog';
import styles from '../bankPaymentRedemption.module.scss';

const getCtaLabel = (isLoading, hasError) => {
  if (isLoading) return dictionary.bankPayment.labels.connectingCta;
  if (hasError) return dictionary.bankPayment.labels.retryCta;
  return dictionary.bankPayment.labels.connectCta;
};

export const ConnectBankView = ({
  onConnect,
  isLoading,
  error,
  onDismissError,
}) => {
  const handleConnect = () => {
    if (error) {
      onDismissError();
    }
    onConnect();
  };

  return (
    <div className={styles.container} data-test-id="bank-payment-connect-view">
      <div className={styles.header}>
        <Heading1>{dictionary.bankPayment.labels.connectTitle}</Heading1>
      </div>
      <p className={styles.body}>
        {interpolate(
          dictionary.bankPayment.copy.connectBody,
          '[br]',
          <br key={null} />,
        )}
      </p>
      <div className={styles.infoTrigger}>
        <BankPaymentInfoDialog />
      </div>
      {error && (
        <p className={styles.error} data-test-id="bank-payment-connect-error">
          {dictionary.bankPayment.errors.initiateFailed}
        </p>
      )}
      <div className={styles.ctaWrapper}>
        <PrimaryButton
          onClick={handleConnect}
          label={getCtaLabel(isLoading, Boolean(error))}
          disabled={isLoading}
          className={styles.cta}
          data-test-id="bank-payment-connect-cta"
        />
      </div>
      <BackButton className={styles.backButton} />
    </div>
  );
};

ConnectBankView.propTypes = {
  onConnect: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  error: PropTypes.any,
  onDismissError: PropTypes.func.isRequired,
};

export default ConnectBankView;
